import { createFileRoute } from '@tanstack/react-router';
import { LeaveHub } from '@/features/leave/LeaveHub';

export const Route = createFileRoute('/_app/leave/')({ component: LeaveHub });

// Modello HR v1 JSON:API con state-machine. Desktop e mobile usano lo stesso hub
// (il vecchio mobile su endpoint plain è stato ritirato perché il BE ha cambiato contratto).
